import type {
  SeriesPropsWithAxes,
  XYChartAxisInternal,
  XYChartVariantsInternal,
} from '../types/xy-chart-internals.js';

export function combineSeriesWithAxes(
  seriesProps: XYChartVariantsInternal[],
  axes: XYChartAxisInternal[],
) {
  const seriesWithAxes: SeriesPropsWithAxes[] = [];

  for (let i = 0; i < seriesProps.length; i++) {
    const series = seriesProps[i];

    const yAxis = axes.find((axis) => axis.id === series.yAxisId);
    const xAxis = axes.find((axis) => axis.id === series.xAxisId);

    if (!yAxis || !xAxis) {
      continue;
    }

    seriesWithAxes.push({ seriesProps: series, xAxis, yAxis });
  }

  return seriesWithAxes;
}
